import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import { updateEquipo, deleteEquipo, fetchEquipo } from '../../../controller/dispositivosController'; // Asegúrate de que las rutas sean correctas
import Dispositivo from '../../../models/dispostivo'; // Asegúrate de que esta ruta sea correcta
import { fetchUsuarioByUserId } from '../../../controller/userController';
import { fetchSucursal } from '../../../controller/sucursalController';

function DispositivosEditView() {
  const navigate = useNavigate();
  const location = useLocation();
  const [equipo, setEquipo] = useState(new Dispositivo(location.state?.equipo || {}));

  const [nombreSucursal, setNombreSucursal] = useState('');
  const [nombreServicio, setNombreServicio] = useState('');


  // Cargar equipo específico al iniciar
useEffect(() => {
  const getEquipo = async () => {
    try {
      const data = await fetchEquipo(equipo.id);
      setEquipo(new Dispositivo(data));

      // Obtener sucursal y servicio por ID
      if (data.sucursal) {
        const sucursalData = await fetchSucursal(data.sucursal);
        setNombreSucursal(sucursalData.name);
      }
      if (data.servicio) {
        const servicioData = await fetchUsuarioByUserId(data.servicio);
        setNombreServicio(servicioData.username);
      }

    } catch (error) {
      console.error('Error al obtener el equipo:', error);
    }
  };

  if (equipo.id) {
    getEquipo();
  }
}, [equipo.id]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setEquipo({
      ...equipo,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const updatedData = { ...equipo };
    // Aquí puedes agregar lógica de comparación de los campos si lo deseas

    try {
      await updateEquipo(equipo.id, updatedData); // Actualiza el equipo
      navigate(-1); // Regresa a la vista anterior
    } catch (error) {
      console.error('Error al actualizar el equipo:', error);
    }
  };

  const handleDelete = async () => {
    const confirmDelete = window.confirm('¿Estás seguro de que deseas eliminar este dispositivo? Esta acción no se puede deshacer.');

    if (confirmDelete) {
      try {
        await deleteEquipo(equipo.id); // Elimina el equipo
        navigate(-1);
      } catch (error) {
        console.error('Error al eliminar el equipo:', error);
      }
    }
  };

  return (
    <Container className="mt-4">
      <Row className="align-items-center mb-4">
        <Col><h1>Editar Dispositivo</h1></Col>
      </Row>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Nombre</Form.Label>
          <Form.Control
            type="text"
            name="name"
            value={equipo.name}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Modelo</Form.Label>
          <Form.Control
            type="text"
            name="model"
            value={equipo.model}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Dirección IP</Form.Label>
          <Form.Control
            type="text"
            name="ip_address"
            value={equipo.ip_address}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Puerto</Form.Label>
          <Form.Control
            type="number"
            name="port"
            value={equipo.port}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Contraseña</Form.Label>
          <Form.Control
            type="password"
            name="password"
            value={equipo.password}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Descripción</Form.Label>
          <Form.Control
            type="text"
            name="description"
            value={equipo.description}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group className="mb-3">
  <Form.Label>Sucursal</Form.Label>
  <Form.Control
    type="text"
    value={nombreSucursal}
    disabled
  />
</Form.Group>

<Form.Group className="mb-3">
  <Form.Label>Servicio</Form.Label>
  <Form.Control
    type="text"
    value={nombreServicio}
    disabled
  />
</Form.Group>


        <Button variant="primary" type="submit" className="me-2">
          Guardar Cambios
        </Button>
        <Button variant="secondary" onClick={() => navigate(-1)}>
          Volver
        </Button>
    
        <Button variant="danger" onClick={handleDelete}>
          Eliminar
        </Button>
      </Form>
    </Container>
  );
}

export default DispositivosEditView;
